import { InvoiceFormData, InvoiceFormDataLineItem } from 'types/invoice';
import { getGeneratedInitialLineItem } from './utils';

export const initialInvoiceFormDataValues: InvoiceFormData = {
    title: '',
    description: '',
    scheduledPayDate: '',
};
